export const BASE_URL = 'https://norma.nomoreparties.space/api';
export const WS_FEED_URL = "wss://norma.nomoreparties.space/orders/all";
export const testUrl = 'http://localhost:3000';
export const dataCy = '[data-cy=list]';
